import styled from 'styled-components'
import { ContentHeader } from '../App'
import Item from './Confirmation/Item'
import Select from './Form/Select'
import Heading from './Heading'
import { useContext, useEffect, useRef, useState } from 'react'
import { OrderItemsContext } from '../context/OrderItemsContext'
import { OrderDataContext } from '../context/OrderDataContext'
import { isWeekend, parse, addMinutes, isBefore, format } from 'date-fns'
import { ErrorContext } from "../context/ErrorContext";
import { MenuContext } from "../context/MenuContext";
import { LocationsContext } from "../context/AvailableDatesContext";
import Api from "../api/api";
import { TranslationContext } from '../context/TranslationContext'

function TimeSelect ({ page }) {
    const myRef = useRef(null)
    const { orderItems } = useContext(OrderItemsContext)
    const { order, setOrder } = useContext(OrderDataContext)
    const { errors, setErrors } = useContext(ErrorContext)
    const { translations } = useContext(TranslationContext)
    const { locations } = useContext(LocationsContext)
    const { menu } = useContext(MenuContext)
    const [reservedTimes, setReservedTimes] = useState([])

    useEffect(() => {
        Api.getReservedTimes(order.date).then(times => {
            setReservedTimes(times)
        })
    }, [])

    useEffect(() => {
        if (errors?.time || errors?.location) {
            myRef.current.scrollIntoView()
        }
    }, [errors])

    useEffect(() => {
        if (order.time) {
            setErrors((prev) => ({ ...prev, time: false }))
        }
    }, [order.time])

    useEffect(() => {
        if (order.location) {
            setErrors((prev) => ({ ...prev, location: false }))
        }
    }, [order.location])

    const setLocation = (value) => {
        setData('location', value)
    }

    const setTime = (value) => {
        setData('time', value)
    }

    const setData = (key, value) => {
        setOrder({
            ...order,
            [key]: value,
        })
    }

    const getHours = () => {
        const date = parse(order.date, 'y-MM-dd', new Date())
        const hours = []
        let increase = true;

        let startCounter = parse('08:15', 'HH:mm', new Date());
        let finishCounter = parse('11:00', 'HH:mm', new Date());
        if (isWeekend(date)) {
            startCounter = parse('09:15', 'HH:mm', new Date());
            finishCounter = parse('11:30', 'HH:mm', new Date());
        }

        if (order.date === '2024-05-25') {
            startCounter = parse('09:15', 'HH:mm', new Date());
            finishCounter = parse('10:45', 'HH:mm', new Date());
        }

        if (order.date === '2025-01-01') {
            startCounter = parse('10:00', 'HH:mm', new Date());
            finishCounter = parse('12:00', 'HH:mm', new Date());
        }

        while (increase) {
            hours.push({
                key: format(startCounter, 'H:mm'),
                value: format(startCounter, 'H:mm')
            })
            startCounter = addMinutes(startCounter, 15);
            if (isBefore(finishCounter, startCounter)) {
                increase = false;
            }
        }

        return hours;
    }

    const getLocations = () => {
        return locations.map(location => {
            return {
                key: location.location,
                value: translations[location.location]
            }
        });
    }


    return (
        <Wrapper>
            <ContentHeader>
                <Heading page={page} />
                {orderItems.length > 0 &&
                    <Order>
                        {Object.keys(orderItems).map(key =>
                            <Item key={key} id={key} quantity={orderItems[key]} items={menu} />
                        )}
                    </Order>
                }
                <Form ref={myRef}>
                    {!order.id && <>
                        <Select
                            setValue={setTime}
                            // defaultValue={order.time}
                            selected={order.time}
                            options={getHours()}
                            disabledOptions={reservedTimes}
                            placeholder={translations.select_breakfast_time}
                            error={errors?.time}
                        />
                        <Select
                            setValue={setLocation}
                            defaultValue={order.location}
                            selected={order.location}
                            options={getLocations()}
                            placeholder={translations.select_breakfast_location}
                            error={errors?.location}
                        />
                    </>}
                    {/* <Textarea placeholder={'Comment (optional)'} value={order.comment} setValue={setComment}/> */}
                </Form>
            </ContentHeader>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`

const Order = styled.div`
    background: #F4F4F4;
    border-radius: 10px;
    padding: 15px;
    margin-top: 40px;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.19);
`

const Form = styled.div`
    margin-top: 20px;

    & > * {
        margin-bottom: 20px;
    }
`

export default TimeSelect;
